import {createInstance as createInstancePano} from '../pano'
import {addChild} from '../util'
import {ENV_DEVELOPMENT} from '../config'
import {init as idleInit} from './idle'
// import gyro from '../../data/interface/baseline-screen_rotation-24px.svg'
import Hammer from 'hammerjs'

const className = {
  mapHide: 'map--hide'
  ,levelCurrent: 'map__level--current'
  ,levelNameCurrent: 'map__level-name--current'
  ,levelNameCurrentSpot: 'map__level-name--current-spot'
  ,spotCurrent: 'map__spot--current'
  ,spotOver: 'map__spot--over'
  ,alignRight: 'map--align-right'
}

const swipe = {
  up: 'swipeup'
  ,down: 'swipedown'
  ,left: 'swipeleft'
  ,right: 'swiperight'
  ,swipe: 'swipe'
}

const mappedProto = {
  /**
   * Override the initialisation method
   * @param {string} name
   * @param {string} xmluri
   * @param {string} startId
   * @returns {mappedProto}
   * @private
   * @override
   */
  _init(name,xmluri,startId){
    this._init.super.call(this,name,xmluri,startId)
    this
        ._initMap(startId)
        //._initGyro()
        ._initEvents()
    setTimeout(::this._toggleMap,2000)
    idleInit(this,5000,true)
    return this
  }
  /**
   * Build the map
   * @param {string} startId
   * @returns {mappedProto}
   * @private
   */
  ,_initMap(startId){
    const body = this.element.ownerDocument.body
    this._mapDiv = addChild(body,'div',{'class':'map'})
    const buttonsWrapper = addChild(this._mapDiv,'div',{'class':'map__buttons'})
    const levelsWrapper = addChild(this._mapDiv,'div',{'class':'map__levels'})
    addChild(this._mapDiv,'button',{'class':'map__label'}).addEventListener('focus',e=>e.currentTarget.blur())
    Object.entries(this._map).forEach(([level,{name,mapspots}])=>{
      const isCurrentLevel = mapspots.map(spot=>spot.target).includes(startId)
      const levelDiv = addChild(levelsWrapper,'div',{'class':`map__level map__level--${level} ${isCurrentLevel?className.levelCurrent:''}`})
      const levelButton = addChild(buttonsWrapper,'button',{'class':`map__level-name map__level-name--${level} ${isCurrentLevel?className.levelNameCurrent+' '+className.levelNameCurrentSpot:''}`,'data-level':level})
      levelButton.textContent = name
      mapspots.forEach(({x,y,target})=>{
        this._mapSpots[target] = addChild(levelDiv,'button',{
          'class':'map__spot'
          ,style:`left:${x}px;top:${y}px;`
          ,type: 'button'
          ,title: `${name} - ${target}`
          ,'data-target':target
        })
      })
    })
    return this
  }
  // /**
  //  * Initialise gyro button if applicable
  //  * @returns {mappedProto}
  //  * @private
  //  */
  // ,_initGyro(){
  //   console.log('wait for deviceorientation') // todo: remove log
  //   const addGyro = () => {
  //     console.log('deviceorientation fired') // todo: remove log
  //     window.removeEventListener('deviceorientation',addGyro)
  //     addChild(this._mapDiv,'button',{'class':'map__gyro',innerHTML:gyro})
  //         .addEventListener('click',::this._onClickGyro)
  //   }
  //   window.addEventListener('deviceorientation',addGyro)
  //   return this
  // }
  /**
   * Add events
   * @returns {mappedProto}
   * @private
   */
  ,_initEvents(){
    this._mapDiv.addEventListener('click',::this._onMapClick)
    // level change
    const {signal} = this
    signal.loadcomplete.add(panoId=>{
      const currentSpot = this._mapDiv.querySelector('.'+className.spotCurrent)
      currentSpot?.classList.remove(className.spotCurrent)
      this._mapSpots[panoId].classList.add(className.spotCurrent)
    })
    // hotspot hover
    signal.over.add(this._toggleMapSpotHover.bind(this,true))
    signal.out.add(this._toggleMapSpotHover.bind(this,false))
    // map spot hover
    this._mapDiv.addEventListener('mouseover',this._toggleHotspotHover.bind(this,true))
    this._mapDiv.addEventListener('mouseout',this._toggleHotspotHover.bind(this,false))
    // editor
    ENV_DEVELOPMENT&&window.addEventListener('keydown',this._onKeyDown.bind(this))
    //
    const mc = new Hammer(this._mapDiv)
    mc.get(swipe.swipe).set({ direction: Hammer.DIRECTION_ALL })
    mc.on(Object.values(swipe).join(' '),this._onSwipe.bind(this))
    //
    return this
  }
  /**
   * Event handler for when a scene has loaded
   * Check in what level the current pano is
   * @param {string} panoId
   * @override
   */
  ,onloadcomplete(panoId){
    this.onloadcomplete.super.call(this,panoId)
    this._rotateCurrentSpot(this._view.hlookat)
    //
    Object.entries(this._map).forEach(([level,{mapspots}])=>{
      const isCurrentLevel = mapspots.map(spot=>spot.target).includes(panoId)
      if (isCurrentLevel){
        const {levelNameCurrentSpot} = className
        this._mapDiv.querySelector(`.${levelNameCurrentSpot}`)?.classList.remove(levelNameCurrentSpot)
        this._mapDiv.querySelector(`.map__level-name--${level}`)?.classList.add(levelNameCurrentSpot)
      }
    })
  }
  /**
   * Event handler for map clicks
   * @param {string} hlookat
   * @private
   */
  ,onviewchange(hlookat){
    this._rotateCurrentSpot(hlookat)
  }
  /**
   * Event handler for map clicks
   * @param {MouseEvent} e
   * @private
   */
  ,_onMapClick(e){
    const {target} = e
    if (target.hasAttribute('data-target')){
      const targetLevel = target.getAttribute('data-target')
      this.loadPanorama(targetLevel)
    } else if (target.classList.contains('map__label')){
      this._toggleMap()
    } else if (target.hasAttribute('data-level')){
      const targetLevel = target.getAttribute('data-level')
      this._mapDiv.querySelector('.'+className.levelCurrent)?.classList.remove(className.levelCurrent)
      this._mapDiv.querySelector(`.map__level--${targetLevel}`).classList.add(className.levelCurrent)
      this._mapDiv.querySelector('.'+className.levelNameCurrent)?.classList.remove(className.levelNameCurrent)
      this._mapDiv.querySelector(`.map__level-name--${targetLevel}`).classList.add(className.levelNameCurrent)
    }
  }
  // /**
  //  * Click gyro button
  //  * @param {MouseEvent} e
  //  * @private
  //  */
  // ,_onClickGyro(e){
  //   this.call('plugin[gyro].toggle()')
  //   const isEnabled = this.get('plugin[gyro].enabled')
  //   e.currentTarget.classList.toggle('map__gyro--enabled',isEnabled)
  // }
  /**
   * Swipe event handler
   * @param {Event} e
   * @private
   */
  ,_onSwipe(e){
    const {type} = e
    const isUp = type===swipe.up
    const isDown = type===swipe.down
    const isLeft = type===swipe.left
    const isRight = type===swipe.right
    //
    const isAlignedRight = this._mapDiv.classList.contains(className.alignRight)
    const isOpen = isAlignedRight?isLeft:isUp
    const isClose = isAlignedRight?isRight:isDown
    //
    const isHidden = this._mapDiv.classList.contains(className.mapHide)
    ;((isHidden&&isOpen)||(!isHidden&&isClose))&&this._toggleMap()
  }
  /**
   * Keydown event handler
   * @param {KeyboardEvent} e
   * @private
   */
  ,_onKeyDown(e){
    const {key,keyCode} = e
    const isKeyQ = key==='q'
    const isKeyE = key==='e'
    const isKeyW = key==='w'
    if (key==='m'||keyCode===32){
      this._toggleMap()
    } else if (isKeyQ||isKeyE){
      const {_view} = this
      _view.mapoffset = parseFloat(_view.mapoffset) + 5*(isKeyE?1:-1)
      this.onviewchange(this._lastHlookat)
      console.log('this._view.mapoffset',this._view.mapoffset)
    } else if (isKeyW){
      console.log('this._view.hlookat',this._view.hlookat)
      console.log('this._view.vlookat',this._view.vlookat)
      console.log('this._view.fov',this._view.fov)
    }
  }
  /**
   * Getter for the map element
   * @returns {HTMLDivElement}
   */
  ,get map(){
   return this._mapDiv
  }
  /**
   * Rotate the current map indicator spot thing
   * @param {string} hlookat
   * @private
   */
  ,_rotateCurrentSpot(hlookat){
    const current = this._mapDiv.querySelector(`.${className.spotCurrent}`)
    const mapRotation = parseFloat(hlookat) + parseFloat(this._view.mapoffset||0)
    current && (current.style.transform = `translate(-25px, -25px) rotate(${mapRotation}deg)`)
    this._lastHlookat = hlookat
  }
  /**
   * Toggle map visibility
   * @private
   */
  ,_toggleMap(){
    this._mapDiv.classList.toggle(className.mapHide)
  }
  /**
   * Toggle hotspot hovers when hovering over map spots
   * @param {boolean} over
   * @param {MouseEvent} e
   * @private
   */
  ,_toggleHotspotHover(over,e){
    const {target} = e
    if (target.hasAttribute('data-target')){
      const targetLevel = target.getAttribute('data-target')
      const hotspot = document.querySelector(`.hotspot--${targetLevel}`)
      hotspot?.classList.toggle('hotspot--over',over)
    }
  }
  /**
   * Toggle map spot hovers when hovering over hotspots
   * @param {boolean} over
   * @param {string} panoId
   * @private
   */
  ,_toggleMapSpotHover(over,panoId){
    const mapSpot = this._mapDiv.querySelector(`[data-target="${panoId}"]`)
    mapSpot?.classList.toggle(className.spotOver,over)
  }
}

/**
 * Create and return the mapped panorama
 * @param {string} name
 * @param {string} xmluri
 * @param {string} startId
 * @param {object} map
 * @returns {Object}
 * @todo write typedef for map
 */
export function createInstance(name,xmluri,startId,map){
  return createInstancePano(name,xmluri,startId,mappedProto,{
    _mapDiv: null
    ,_lastHlookat: null
    ,_mapSpots: {}
    ,_map: map
  })
}


// WEBPACK FOOTER //
// ./src/js/pano/mappedPano.js